import store from "./store";

export const reduxGetGameInfo = (dataName) => {
  if (!dataName || dataName === "") return null;

  const state = store.getState();
  return state ? state[dataName] : null;
};

export default reduxGetGameInfo;